import { GridOptions } from 'ag-grid-community'
import { isProductLineColumnHeaderRightClickMenuVar } from 'cache/product-line-summary'
import { createAgGridFrameworkComponents } from 'components/AgGrid'

export const frameworkComponents: Record<string, any> = createAgGridFrameworkComponents(
  isProductLineColumnHeaderRightClickMenuVar
)

export const productLineGridOptions: Partial<GridOptions> = {
  treeData: true,
  getDataPath: (data) => data.hierarchyPath,
  autoGroupColumnDef: {
    headerName: 'Product Hierarchy',
    width: 200,
    cellRendererParams: {
      suppressCount: true,
      innerRenderer: (params: any) => {
        return params.data?.hierarchyCode || ''
      },
    },
  },
  groupDefaultExpanded: -1,
  suppressRowClickSelection: false,
  suppressCellFocus: false,
  stopEditingWhenCellsLoseFocus: true,
  rowSelection: 'single',
  animateRows: true,
  enableRangeSelection: false,
  suppressMenuHide: true,
  tooltipShowDelay: 500,
  enableCellTextSelection: false,
  ensureDomOrder: true,
  rowHeight: 32,
  headerHeight: 36,
  suppressContextMenu: true,
  preventDefaultOnContextMenu: false,
  getRowId: (params) => params.data.id?.toString() || '',
}
